import React from 'react';
import FirstContent from './FirstContent/FirstContent';
import MenuNodes from './MenuNodes/MenuNodes';
import './MainView.scss';
import QuizContainer from './Quiz/QuizContainer';
import Example1 from './Example/Example_1';
import Account from './Account/Account';
import Favorites from './Favorites/Favorites';
import Troubles from './Troubles/Troubles';
import Library from './Library/Library';
import TroublesForQuiz from './Troubles/TroublesForQuiz/TroublesForQuiz';
import Notes from './Notes/Notes';
import Contacts from './Contacts/Contacts';
import Messages from './Messages/Messages';
import SendBox from './SendBox/SendBox';
import Tasks from './Tasks/Tasks';
import Subscriber from './Subscriber/Subscriber';
import { showMenuView } from '../Menu/MenuSide/menuSideSlice';


export default class MainView extends React.Component {
    constructor(props) {
        super(props);
        
        this.handleClickShader = this.handleClickShader.bind(this);
        
    }
//RENDER MENU NODES

renderMenuNodes() {
    const { dispatch } = this.props;
  
    return (
        <div>
            <MenuNodes 
            authData = {this.props.authData}
            favoritesQuizes ={this.props.authData.favoriteQuizes}
            userId={this.props.authData.id}
            quizViewChangeRedux={this.props.quizViewChangeRedux}
            menuSide={this.props.menuSide}
            dispatch={dispatch}
            />
        </div>
    )
}
//RENDER QUIZ

renderQuizContainer() {
    const { dispatch } = this.props;
    return (
        <div className='main-container'>
            <QuizContainer 
            quizRedux={this.props.quizViewChangeRedux}
            dispatch={dispatch}
           // onAnswerSelected={this.props.onAnswerSelected}
            //nextQuestion={this.props.nextQuestion}
            userId={this.props.authData.id}
            finishedQuizes={this.props.authData.finishedQuizes}
            moduleData = {this.props.menuSide.dataMenuNodes}
            previousModule = {this.props.menuSide.previousModule}
            dataNotes = {this.props.dataNotes}
            authData = {this.props.authData}
           />

           
        </div>
    )
}

//RENDER ACCOUNT
renderAccount () {
    const { dispatch } = this.props;
    return (
        <div className='main-services'>
            <Account
                authData ={this.props.authData}
                accountView={this.props.menuSide.accountView}
                dispatch={dispatch}
                accountData={this.props.accountData}
            />
        </div>
    )
}
//RENDER FAVORITES
renderFavorites () {
    const { dispatch } = this.props;
    return (
        <div className='main-services'>
            <Favorites
            dataNotes = {this.props.dataNotes}
            authData ={this.props.authData}
            favoritesView={this.props.menuSide.favoritesView}
            dispatch={dispatch}
            />
        </div>
    )
}
//RENDER FAVORITES
renderMessages () {
    const { dispatch } = this.props;
    return (
        <div className='main-services'>
            <Messages
               authData ={this.props.authData}
               messagesData ={this.props.messagesData}
               messagesView={this.props.menuSide.messagesView}
               userId={this.props.authData.id}
               dispatch={dispatch}
               dataNotes = {this.props.dataNotes}
            />
        </div>
    )
}

//EXAMPLE 
renderExample() {
    
        
        return (
            <div>
                <Example1  />
            </div>
        );
    
}

//TROUBLES
renderTroubles() {
    const {dispatch} = this.props;
    return (
        <div>
            <Troubles
            troublesView={this.props.menuSide.troublesView}
            dispatch={dispatch}
            />
        </div>
    )
}
//NOTES
renderNotes() {
    const {dispatch} = this.props;
    return (
        <div className='main-services'>
            <Notes
            authData ={this.props.authData}
            userId ={this.props.authData.id}
            troublesData={this.props.troublesData}
            dataNotes = {this.props.dataNotes}
            notesView={this.props.menuSide.notesView}
            notesDataSlice={this.props.notesDataSlice}
            moduleData = {this.props.menuSide.dataMenuNodes}
            quizActive = {this.props.menuSide.quizActive}
            previousModule = {this.props.menuSide.previousModule}
            dataTroubles = {this.props.dataTroubles}
            dataAnswerTroubles = {this.props.dataAnswerTroubles}
            foldererView = {this.props.notesDataSlice.foldererView}
            noteAddFiles = {this.props.noteAddFiles}
            adminPdfViewer= {this.props.adminPdfViewer}
            pdfName = {this.props.pdfName}
            selectedIdAnswerTrouble={this.props.selectedIdAnswerTrouble}
            selectedIdTrouble={this.props.selectedIdTrouble}
            dispatch={dispatch}

            />
        </div>
    )
}
//LIBRARY
renderLibrary() {
    const {dispatch} = this.props;
    return (
        <div className='main-services'>
            <Library
                libraryView={this.props.menuSide.libraryView}
                libraryData={this.props.libraryData}
                dispatch={dispatch}
            />
        </div>
    )
}
//TROUBLES
renderTroublesForQuiz() {
    const {dispatch} = this.props;
    return (
        <div>
            <TroublesForQuiz
            troublesForQuizView={this.props.quizViewChangeRedux.troublesForQuizView}
            dispatch={dispatch}
            />
        </div>
    )
}
//SUBSCRIBER
renderSubscriber() {
    const {dispatch} = this.props;
    return (
        <div>
            <Subscriber
            subscription={this.props.authData.subscription}
            dispatch={dispatch}
            />
        </div>
    )
}
//CONTACTS
renderContacts() {
    const {dispatch} = this.props;
    return (
        <div className='main-services'>
            <Contacts
            userId={this.props.authData.id}
            findContact={this.props.authData.findContact}
            contactsData={this.props.authData.contacts}
            contactsGroupsData={this.props.authData.contactsGroups}
            contactsView = {this.props.menuSide.contactsView}
            contactsStore = {this.props.contactsStore}
            errorMessageGroupContact = { this.props.authData.errorMessageGroupContact}
            errorMessageUserGroupContact = { this.props.authData.errorMessageUserGroupContact}
            dispatch={dispatch}
            />
        </div>
    )
}
//TASKS
renderTasks() {
    const {dispatch} = this.props;
    return (
        <div className='main-services'>
            <Tasks
            userId={this.props.authData.id}
            authData ={this.props.authData}
            taskView = {this.props.menuSide.taskView}
            taskMineView = {this.props.menuSide.taskMineView}
            tasksDataMain = {this.props.tasksDataMain.tasksDataMain}
            tasksData = {this.props.tasksDataMain}
            dataNotes = {this.props.dataNotes}
            dispatch={dispatch}
            />
        </div>
    )
}
//SEND BOX
//CONTACTS
renderSendBox() {
    const {dispatch} = this.props;
    return (
        <div>
            <SendBox
            contactsData ={this.props.authData.contacts}
            contactsStore = {this.props.contactsStore}
            userId={this.props.authData.id}
            mesCategory={this.props.authData.usermesCategory}
            dispatch={dispatch}
            noteData={this.props.notesDataSlice}
            mesHref={this.props.messagesData.mesHref}
            quizId={this.props.quizViewChangeRedux.quizId}
            quizName={this.props.quizViewChangeRedux.quizName}
            />
        </div>
    )
}




//SHADE FOR SENDBOX
renderShadeMainView() {
    //const {dispatch} = this.props;
    return (
        <div className='shader'>
           
        </div>
    )
}
//SHADE FOR MENU
renderShadeMainViewForMenu() {
    //const {dispatch} = this.props;
    return (
        <div className='shader-menu' onClick={this.handleClickShader}>
           
        </div>
    )
}
// UNSHADE FOR MENU
handleClickShader() {
    const {dispatch} = this.props;
   // const shaderDiv = document.getElementsByClassName('shader-menu');

    dispatch(showMenuView());
}





    render() {


        
        return (
            
            <div className="MainView">
                
             
             {/* <Category categoryView={this.props.categoryView} idCategory={this.props.idCategory} /> */}

              { this.props.menuSide.firstContentView ? <FirstContent firstContentView={this.props.menuSide.firstContentView} /> :null }

               {this.props.menuSide.categoryView ? this.renderMenuNodes() : null}
               {this.props.menuSide.quizView ? this.renderQuizContainer() : null}
               {/*this.renderExample()*/} 
               {this.props.menuSide.accountView ? this.renderAccount() : null}
               {this.props.menuSide.favoritesView ? this.renderFavorites() : null}
               {this.props.menuSide.troublesView ? this.renderTroubles() : null}
               {this.props.menuSide.libraryView ? this.renderLibrary() : null}
                {/*this.props.menuSide.troublesView ? this.renderTroublesForQuiz() : null */}
                {this.props.menuSide.subscriberView ? this.renderSubscriber() : null}
                {this.props.menuSide.notesView ? this.renderNotes() : null}
                {this.props.menuSide.contactsView ? this.renderContacts(): null}
                {this.props.menuSide.messagesView ? this.renderMessages(): null}

                {this.props.menuSide.taskView ? this.renderTasks() : null}
                {this.props.menuSide.taskMineView ? this.renderTasks() : null}

                {this.props.contactsStore.openSendBox ? this.renderSendBox() : null}
                {this.props.contactsStore.shadeView ? this.renderShadeMainView(): null}
                {this.props.menuSide.menuSideView? this.renderShadeMainViewForMenu(): null}
               

            </div>
            )
    }
}